export const TROPHY_IMGS = {
    0: require('../assets/images/bronze-trophy.png'),
    1: require('../assets/images/silver-trophy.png'),
    2: require('../assets/images/gold-trophy.png'),
    3: require('../assets/images/platinum-trophy.png'),
    4: require('../assets/images/diamond.png'),
};
